<template>
  <div class="components-container">
    <el-form v-loading="loading" ref="handbook" label-position="right" label-width="100px">

      <div class="flex_row">
        <el-form-item :label="$t('doc.PlatformType')" prop="type">
          <el-select v-model="handbook.platform" class="filter-item" :disabled="handbook.menu?true:false"
            @change="init">
            <el-option v-for="item in platformList" :key="item.key" :label="item.value" :value="item.key" />
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('doc.Category')">
          <el-cascader v-model="typeVal" :options="typeOptions" :placeholder="$t('button.select')" clearable />
        </el-form-item>
        <el-form-item :label="$t('doc.Sort')" prop="orderNum">
          <el-input v-model="handbook.orderNum" />
        </el-form-item>

        <div class="flex_end flex_one">
          <el-button type="primary" @click="saveDoc">{{$t('button.Submit')}}</el-button>
        </div>

      </div>

      <el-form-item :label="'选择语言'" prop="valueZhCn">
        <el-select v-model="langue" placeholder="请选择" @change="changeLangue" @focus="saveContent">
          <el-option value="valueZhCn" label="中文简体"> </el-option>
          <el-option value="valueZhHk" label="中文繁體"> </el-option>
          <el-option value="valueEn" label="English"> </el-option>
          <el-option value="valueKo" label="한국어"> </el-option>
          <el-option value="valueJa" label="日本語"> </el-option>
          <el-option value="valueDe" label="Deutsch"> </el-option>
          <el-option value="valueFr" label="Français"> </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="'标题'" prop="valueZhCn">
        <el-input v-model="title" />
      </el-form-item>
      <el-form-item :label="'内容'" prop="valueZhCn">
        <tinymce v-if="isShowTinymce" v-model="content" />
      </el-form-item>

    </el-form>

  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import { addDoc, editDoc, detailDoc, getTypeList, platformListLang } from '@/api/doc'
import { mapState } from 'vuex'

export default {
  name: 'TinymceDemo',
  components: { Tinymce },
  data () {
    return {
      lang: 'ZhCn',
      langue: 'valueZhCn',
      title: '',
      content: '',
      platformList: [],
      handbook: {
        titleId: '',
        contentId: '',
        menu: this.$route.query.currentKey,
        platform: this.$route.query.currentPlatform,
        orderNum: null
      },
      titleObj: {
        valueZhCn: '',
        valueZhHk: '',
        valueEn: '',
        valueDe: '',
        valueFr: '',
        valueJa: '',
        valueKo: ''
      },
      contentObj: {
        valueZhCn: '',
        valueZhHk: '',
        valueEn: '',
        valueDe: '',
        valueFr: '',
        valueJa: '',
        valueKo: ''
      },
      typeList: null,
      typeOptions: [],
      typeVal: [],
      key: 1,
      isShowTinymce: false,
      loading: true
    }
  },
  computed: {
    ...mapState(['language'])
  },
  watch: {
    '$i18n.locale' (val) {
      this.viewType()// 分类--链级下拉框国际化
      this.queryList()// 获取分类
    }
  },
  created () {

    this.init()
    if (this.handbook.menu) {
      setTimeout(() => {
        this.queryDetail()
      }, 800)
    }
    setTimeout(() => {
      this.queryList()// 获取分类
    }, 1000)
  },
  methods: {
    saveContent () {
      console.log('保存到对应的值：', this.langue)
      this.titleObj[this.langue] = this.title
      this.contentObj[this.langue] = this.content
    },
    queryList () { // 获取分类
      platformListLang(this.$i18n.locale).then(res => {
        if (res.resultCode == 1001) {
          this.lang = this.language[0].toUpperCase() + this.language.slice(1)// 因为后台返回的字段是Fr等
          if (this.language == 'zh_CN' || this.language == 'zh_HK') {
            this.lang = this.language == 'zh_CN' ? 'ZhCn' : 'ZhHk'
          }
          if (!this.$store.state.webInfo.webUrl) { // GPD
            this.platformList = res.resultModel || []
          } else {
            var moduleArr = (this.$store.state.webInfo && this.$store.state.webInfo.onlineHandbookModule) ? this.$store.state.webInfo.onlineHandbookModule.split(',') : []
            this.platformList = []
            var arr = res.resultModel || []
            arr.forEach(v => {
              if (moduleArr.indexOf(v.key) > -1) {
                this.platformList.push(v)
              }
            })
          }
        }
      })
    },
    init () {
      if (!this.handbook.menu) {
        this.loading = true
        this.isShowTinymce = false
      }
      getTypeList(this.handbook.platform != null ? this.handbook.platform : (this.$route.query.currentPlatform ? this.$route.query.currentPlatform : 'Y-Hub')).then(res => {
        console.log('分类：', res)
        this.typeOptions = []
        if (!this.handbook.menu) {
          this.loading = false
          this.isShowTinymce = true
        }
        if (res.resultCode == 1001 && res.resultModel) {
          this.typeList = res.resultModel
          this.viewType()// 分类--链级下拉框国际化
        }
      })
      this.key++
    },
    viewType () { // 分类--链级下拉框国际化
      this.typeOptions = []
      this.typeList.forEach(v => {
        if (v.level == 1) {
          var type = {}
          var childrenType = []
          this.lang = this.language[0].toUpperCase() + this.language.slice(1)// 因为后台返回的字段是Fr等
          if (this.language == 'zh_CN' || this.language == 'zh_HK') {
            this.lang = this.language == 'zh_CN' ? 'ZhCn' : 'ZhHk'
          }
          this.typeList.forEach(m => {
            if (m.level == 2 && m.parentCode == v.code) {
              childrenType.push({ 'value': m.code, 'label': m['txt' + this.lang] })
            }
          })
          if (childrenType.length > 0) {
            type = { 'value': v.code, 'label': v['txt' + this.lang], 'children': childrenType }
          } else {
            type = { 'value': v.code, 'label': v['txt' + this.lang] }
          }
          this.typeOptions.push(type)
        }
      })
    },
    changeLangue () {
      this.isShowTinymce = false
      setTimeout(() => {
        this.isShowTinymce = true
      }, 500);

      this.title = this.titleObj[this.langue]
      this.content = this.contentObj[this.langue] || ''
    },
    queryDetail () {
      this.loading = true
      detailDoc({ platform: this.handbook.platform, menu: this.handbook.menu }).then(res => {
        console.log('文档详情', res)
        this.loading = false
        if (res.resultCode == 1001 && res.resultModel) {

          this.handbook.titleId = res.resultModel.title.id
          this.handbook.contentId = res.resultModel.content.id
          this.handbook.orderNum = res.resultModel.title.orderNum ? res.resultModel.title.orderNum : 0
          if (res.resultModel.typeList.length) {
            this.typeVal = res.resultModel.typeList[0].parentCode ? [res.resultModel.typeList[0].parentCode, res.resultModel.typeList[0].code] : [res.resultModel.typeList[0].code]
          }

          this.titleObj = res.resultModel.title
          this.contentObj = res.resultModel.content
          this.changeLangue()
        }
        
      })
    },
    saveDoc () {
      this.saveContent()
      if (!this.titleObj.valueZhCn) {
        this.$message({
          type: 'error',
          message: this.$t('doc.titleCannotbeEmpty')
        })
        return
      }
     
      if (!this.handbook.menu) {
        const param = {
          ...this.titleObj,
          platform: this.handbook.platform,
          orderNum: this.handbook.orderNum ? parseInt(this.handbook.orderNum) : 0,
          typeCodeList: this.typeVal.length > 0 ? [this.typeVal[this.typeVal.length - 1]] : [],
          content: this.contentObj
        }
        
        console.log('新增', param)
        addDoc(param).then((res) => {
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: this.$t('warningSet.submitted') // 成功
            })
            this.$router.go(-1)
          } else {
            this.$message({
              type: 'error',
              message: res.resultMessage // 失败
            })
          }
        })
      } else {
        const param = {
          title: {
            ...this.titleObj,
            id: this.handbook.titleId,
            menu: this.handbook.menu,
            orderNum: this.handbook.orderNum ? parseInt(this.handbook.orderNum) : 0
          },
          content: {
            ...this.contentObj,
            id: this.handbook.contentId,
            menu: this.handbook.menu
          },
          typeCodeList: this.typeVal.length > 0 ? [this.typeVal[this.typeVal.length - 1]] : []
        }
        console.log('编辑', param)
        editDoc(param).then((res) => {
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: this.$t('warningSet.submitted') // 成功
            })
            this.$router.go(-1)
          } else {
            this.$message({
              type: 'error',
              message: res.resultMessage // 失败
            })
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.components-container {
  margin: 30px 50px;
  position: relative;
  margin-top: 10px;
  margin-left: 10px;
}
.el-cascader {
  width: 100%;
}
</style>
